/**
 * Важное
 */
require('popper.js/dist/popper.min');
require('../../modules/index.esm')

/**
 * Сам проект
 */
require('./project/esm');
require('./project/index');

/**
 * Модули проекта
 */
require('./project/src/modules/analytics/analytics');
require ('./project/src/modules/social');
require('./project/src/modules/video');
require('./project/src/modules/map');
require('./project/src/modules/list_rollup');

// Анимация прокрутки
//window.AOS = require('aos/dist/aos');

// Модалки от фансибокса
window.fbx = require('@fancyapps/ui/dist/fancybox.esm');
